<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_user_app']">
              <a-input :placeholder="language['common.pleaseInput']+language['gift_user_app']" v-model="queryParam.appName" disabled ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-model-item :label="language['gift_app_delivery_date']"
                               :labelCol="labelCol">
              <a-select v-model="queryParam.delivery"
                        :placeholder="language['common.pleaseChoose'] + language['gift_app_delivery_date']" >
                <a-select-option v-for="(item) in delivery.deliveryList" :key="item" :value="item">
                  {{ delivery.deliveryMap[item] }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
<!--              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('库存报表')" >{{language['common.exportButton']}}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="false"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'gift:qa:edit'">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'gift:qa:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <template slot='content'  slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span >{{text}}</a-span>
          </div>
        </template>

        <template slot='appName'  slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span >{{appLimit.appCodeNameMap[text]}}</a-span>
          </div>
        </template>

      </a-table>
    </div>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '../../../../api/manage'

  export default {
    name: 'QaList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {

    },
    data () {
      const language = this.$store.getters.language;
      return {
        disableMixinCreated: true,
        description: 'Q&A管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:language['gift_product_code'],
            align:"center",
            width: 120,
            dataIndex: 'productCode',
            scopedSlots: { customRender: 'content' },
          },
          {
            title:language['gift_product_name'],
            align:"center",
            width: 200,
            dataIndex: 'productName',
            scopedSlots: { customRender: 'content' },
          },
          {
            title:language['gift_product_total_stock'],
            align:"center",
            width: 100,
            dataIndex: 'allCount'
          },
          {
            title:language['gift_product_saled'],
            align:"center",
            width: 100,
            dataIndex: 'saleCount'
          },
          {
            title:language['gift_product_remaining_stock'],
            align:"center",
            width: 100,
            dataIndex: 'balance',
            scopedSlots: { customRender: 'productStock' },
          },
          {
            title:language['gift_product_price'],
            align:"center",
            width: 100,
            dataIndex: 'price'
          },
          {
            title:language['gift_product_business'],
            align:"center",
            dataIndex: 'supplierName',
            scopedSlots: { customRender: 'content' },
            width:200,
          }
        ],
        url: {
          list: "/carnival/report/stock",
          exportXlsUrl: "/carnival/report/stock-xls",
          appDeliveryList :"/carnival/appDeliveryList"
        },
        dictOptions:{},
        superFieldList:[],
        appLimit:{
          limit:false,
          appCodeNameMap:[],
          activeAppCode: undefined,
        },
        queryParam:{
          appCode : undefined,
          delivery: undefined,
        },
        delivery:{
          deliveryList: [],
          deliveryMap: [],
        }
      }
    },
    created() {
       this.getDeliveryList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      async getDeliveryList(){
        await getAction(this.url.appDeliveryList).then(res=>{
          this.delivery = res.result;
          this.queryParam.appName = res.result.appName;
          if (this.delivery.deliveryList.length>0){
             this.queryParam.delivery = this.delivery.deliveryList[0];
          }
        })
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
.slot-content{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
}

</style>
